import { usePopup } from "react-hook-popup";
import SFErrorDialog from "../components/SFErrorDialog";

function useSFAlert() {
  return usePopup("myalert", (props) => {
    const { message, handleClose } = props;
    return (
      <SFErrorDialog type={0} content={message} handleClose={handleClose} />
    );
  });
}

export default useSFAlert;
